module.exports = __webpack_public_path__ + "static/media/wheel-alignment-red.b5848ad6.svg";